// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Ol_R","header":"PatientBlock_header__1omzR","label":"PatientBlock_label__2ZSj-","option":"PatientBlock_option__2MbwP"};